import { useInitialProfileHomePageUrl } from "@nf/common";

import { useRouter } from "./useRouter";

export const useGoBackOrHome = () => {
  const router = useRouter();
  const initialHomePage = useInitialProfileHomePageUrl();

  const goBackOrHome = () => {
    if (window.history.length > 2) {
      router.back();
    } else {
      router.push(initialHomePage);
    }
  };

  return goBackOrHome;
};
